import LanguageSDKSwitcher from 'components/LanguageSDKSwitcher';
import styled from 'styled-components';

export const Content = styled.div`
  p {
    margin-top: 0;
  }

  ul {
    padding-left: 25px;
  }
`;

export const LanguageSDKSwitcherStyled = styled(LanguageSDKSwitcher)`
  position: initial;
`;
